import React from 'react';
import { Box, Grid, Alert } from '@mui/material';
import { useRecoilState } from 'recoil';
import Form from 'pages/myidm/components/Form';
import { OrderPayload } from 'pages/myidm/store';
import StaticText from 'shared/Common/StaticText';
import { CancelRequest } from '../../CancelRequest';
import { SubmitRequest } from './SubmitRequest';

const ResourceSectionForAdGroupOwnerChange = () => {
    const [order] = useRecoilState(OrderPayload);

    return (
        <>
            <Grid item md={6} sm={6} xs={12}>
                <Form.ADGroup />
            </Grid>
            {order?.adGroup && (
                <>
                    <Grid item md={6} sm={6} xs={12}>
                        <StaticText label="Current Group Owner" value={order?.adGroupOwner || 'N/A'} />
                    </Grid>
                    <Grid item md={6} sm={6} xs={12}>
                        <Form.GroupOwner />
                    </Grid>
                    <Grid item xs={12}>
                        <Alert severity="warning">
                            Changing the group owner will transfer all administrative privileges for this Active Directory group to the new owner.
                        </Alert>
                    </Grid>
                </>
            )}
            {order?.groupOwner && (
                <Grid item md={12} sm={12} xs={12}>
                    <Box display="flex" id="test" alignItems="baseline" justifyContent="flex-end">
                        <Box display="flex" flexDirection="row" gap={1} sx={{ mt: 1, alignItems: 'baseline' }}>
                            <Box sx={{ marginTop: '0px' }}>
                                <CancelRequest />
                            </Box>
                            <SubmitRequest />
                        </Box>
                    </Box>
                </Grid>
            )}
        </>
    );
};

export default ResourceSectionForAdGroupOwnerChange;
